import React from 'react';
import AppointmentHistory from "./AppointmentHistory";
import MesureStore from "../../MesureStore";
import {t} from "../../../../I18n/i18n"

function AppointmentsHistory() {
    const appointments = MesureStore.last_appointements

    if(!appointments?.length) return null
    const importableAppointments = appointments.filter(appointment => {
        return appointment.comment || appointment.orthoptic_text || (appointment.mesures?.length > 0);
    });
    return <div>
        <h6>{t("PREVIOUS_CONSULTATION")}</h6>
        <div style={{display: "flex", flexDirection: "column", gap: 10, overflowX: "clip"}}>
            {importableAppointments.map((appointment, index) => {
                return <div key={index}>
                    <AppointmentHistory appointment={appointment} is_most_recent_appointment={index===0}/>
                </div>
            })}
        </div>
    </div>
}

export default AppointmentsHistory;